import { inputStyle, labelStyle, RangeInput } from "./utils";

export const BusinessWinnersFilters = ({
    textItems,
    handleTextItemsChange,
    rangeItems,
    handleRangeItemsChange,
}) => {
    const { q = "", business_nui = "" } = textItems || {};
    const { min_prize_amount = "", max_prize_amount = "" } = rangeItems;

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
                <label htmlFor="q" className={labelStyle}>Kërko (biznes / fitues / lojë):</label>
                <input
                    name="q"
                    id="q"
                    type="text"
                    value={q}
                    onChange={handleTextItemsChange}
                    className={inputStyle}
                    placeholder="Kërko sipas emrit të biznesit, fituesit ose lojës"
                />
            </div>
            <div className="flex flex-col gap-2">
                <label htmlFor="business_nui" className={labelStyle}>NUI i biznesit:</label>
                <input
                    name="business_nui"
                    id="business_nui"
                    type="text"
                    value={business_nui}
                    onChange={handleTextItemsChange}
                    className={inputStyle}
                    placeholder="Shkruani NUI-n e biznesit"
                />
            </div>
            <RangeInput
                type="number"
                start_name="min_prize_amount"
                end_name="max_prize_amount"
                label="Vlera e shpërblimit"
                start_placeholder="Nga"
                end_placeholder="Deri"
                start_value={min_prize_amount}
                end_value={max_prize_amount}
                handleValueChange={handleRangeItemsChange}
            />
        </div>
    );
};
